import type { TenantConfig } from '@/shared/providers/tenantConfig';
import { HITOWA_BRAND } from '../../constants/brand';

/**
 * Hitowa tenant config — feature flags and locale settings.
 * Counterpart of the backend's `app/Tenants/Hitowa/Config/tenant.php`.
 */
export const hitowaConfig: TenantConfig = {
  name: 'Hitowa',
  code: 'hitowa',
  description: 'Hitowa Medical Clinic System',
  enabled: true,
  theme: {
    primaryColor: HITOWA_BRAND.brand,
    secondaryColor: HITOWA_BRAND.accent,
    backgroundColor: HITOWA_BRAND.canvas,
    textColor: HITOWA_BRAND.inkBody,
    logo: '/images/hitowa/keilog_icon.png',
  },
  features: {
    patients: true,
    consents: true,
    rezepts: true,
    visits: true,
    unifiedPortal: true,
  },
  settings: {
    dateFormat: 'YYYY年MM月DD日',
    currency: '円',
    language: 'ja',
  },
};
